import * as React from 'react';
import { Field, Form } from 'formik';
import * as Yup from 'yup';
// TODO: This should be in a container and not in the component
import { navigate } from '~/router';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';


const ForceChangePasswordSchema = Yup.object().shape({
  password: Yup.string().required('Required'),
  newPassword: Yup.string().required('Required'),
  newPassword2: Yup.string().test('match', 'Passwords do not match.', function (newPassword2: string) {
    return newPassword2 == this.options.parent.newPassword;
  }),
  acceptTerms: Yup.boolean().required('Required'),
});


const ForcePasswordChangeForm = ({ userName, error, onSubmit, submitting }) => {
  const btnText = submitting ? 'Updating...' : 'Update Password';

  return (
    <FormikForm
      initialValues={{
        password: '',
        newPassword: '',
        newPassword2: '',
        accepTerms: false,
      }}
      onSubmit={(data) => onSubmit(ForceChangePasswordSchema.cast(data))}
      validationSchema={ForceChangePasswordSchema}
      render={(props) => {
        return (
          <Form className="form__cont form--force">

            <div className="form--force__head">
              <a
                href="javascript:void(null)"
                className="btn btn--text btn--il"
                onClick={(e) => navigate('login')}
              >
                <span className="i i-tri-l-fill" /> Back</a>
              <div className="head__title">Change Password</div>
            </div>
            <div className="form__note--msg">Please update your password to continue.</div>

            <Field
              name="password"
              label="Current Password"
              className="input input--lg"
              type="password"
              component={Input}
            />
            <Field
              name="newPassword"
              label="New Password"
              className="input input--lg"
              type="password"
              component={Input}
            />
            <Field
              name="newPassword2"
              label="Repeat New Password"
              className="input input--lg"
              type="password"
              component={Input}
            />

            <div className="input--checkbox--inline">
              <Field
                name="acceptTerms"
                label="I agree to the "
                className="input--checkbox"
                type="checkbox"
                component={Input}
              />
              <a
                className="input--checkbox__anch"
                 href="https://www.relaypayments.com/legal"
                 target="_blank"
              >terms of service.</a>
            </div>

            {error && <div className="form__note">{error}</div>}
            <button className="btn btn--prim btn--xlg fw" disabled={submitting} type="submit">
              {btnText}
            </button>

          </Form>
        );
      }}
    />
  );
};

export default ForcePasswordChangeForm;
